// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
}
@media (max-width: 768px) {
  .invoice-form-container {
    padding: 1rem;
  }
}
.invoice-form-container .no-spinner::-webkit-outer-spin-button,
.invoice-form-container .no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.invoice-form-container .invoice-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: invoice-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .invoice-form-container .invoice-form-wrapper {
    padding: 1rem;
    width: 95%;
  }
}
.invoice-form-container .invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.invoice-form-container .invoice-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0.5rem;
}
.invoice-form-container .invoice-form-header .invoice-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .invoice-form-container .invoice-form-header .invoice-form-title {
    font-size: 1.25rem;
  }
}
.invoice-form-container .invoice-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.invoice-form-container .invoice-form-content {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
}
.invoice-form-container .form-section {
  background: transparent;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
}
.invoice-form-container .form-section:last-of-type {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .invoice-form-container .form-section {
    padding: 1rem;
  }
}
.invoice-form-container .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.invoice-form-container .form-section h3 .invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.invoice-form-container .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.invoice-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .invoice-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.invoice-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.invoice-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.invoice-form-container .form-group label .invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.invoice-form-container .form-group input,
.invoice-form-container .form-group select,
.invoice-form-container .form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.invoice-form-container .form-group input:focus,
.invoice-form-container .form-group select:focus,
.invoice-form-container .form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.invoice-form-container .form-group input:hover:not(:focus),
.invoice-form-container .form-group select:hover:not(:focus),
.invoice-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.invoice-form-container .form-group input::placeholder,
.invoice-form-container .form-group select::placeholder,
.invoice-form-container .form-group textarea::placeholder {
  color: #9ca3af;
}
.invoice-form-container .form-group input:disabled,
.invoice-form-container .form-group select:disabled,
.invoice-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.invoice-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.invoice-form-container .form-group textarea {
  height: auto;
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.invoice-form-container .form-group .amount-display {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  font-weight: 600;
  color: #059669;
  background: #ecfdf5;
  border: 1px solid #d1fae5;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  min-width: 100px;
}
.invoice-form-container .added-services-container {
  margin-bottom: 1.5rem;
}
.invoice-form-container .added-services-container .service-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 1rem;
  transition: all 0.2s ease;
}
.invoice-form-container .added-services-container .service-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.invoice-form-container .added-services-container .service-card .service-card-content {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-card-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
}
.invoice-form-container .added-services-container .service-card .service-card-main {
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-card-main {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
}
.invoice-form-container .added-services-container .service-card .service-info {
  flex: 1 1;
}
.invoice-form-container .added-services-container .service-card .service-info h4 {
  margin: 0 0 0.25rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}
.invoice-form-container .added-services-container .service-card .service-info .service-description {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  font-style: italic;
}
.invoice-form-container .added-services-container .service-card .service-details {
  display: flex;
  gap: 1rem;
  align-items: center;
  font-size: 0.875rem;
  color: #4b5563;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-details {
    justify-content: space-between;
  }
}
.invoice-form-container .added-services-container .service-card .service-details .service-amount {
  font-weight: 600;
  color: #059669;
  font-size: 1rem;
}
.invoice-form-container .added-services-container .service-card .service-card-actions {
  display: flex;
  gap: 0.5rem;
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-card-actions {
    margin-left: 0;
    justify-content: center;
  }
}
.invoice-form-container .added-services-container .service-card .service-card-actions .edit-service-btn {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .edit-service-btn:hover:not(:disabled) {
  background-color: #2563eb;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .edit-service-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .delete-service-btn {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .delete-service-btn:hover:not(:disabled) {
  background-color: #dc2626;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .delete-service-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.invoice-form-container .current-service-form {
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
}
.invoice-form-container .current-service-form .service-form-header {
  margin-bottom: 1rem;
}
.invoice-form-container .current-service-form .service-form-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}
.invoice-form-container .current-service-form .service-form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .invoice-form-container .current-service-form .service-form-row {
    flex-direction: column;
    gap: 0.75rem;
  }
}
.invoice-form-container .current-service-form .service-description-row {
  margin-bottom: 1rem;
}
.invoice-form-container .current-service-form .service-description-row .description-group {
  flex: 1 1;
}
.invoice-form-container .current-service-form .service-form-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .invoice-form-container .current-service-form .service-form-actions {
    flex-direction: column;
  }
}
.invoice-form-container .current-service-form .service-form-actions .add-current-service-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .current-service-form .service-form-actions .add-current-service-btn:hover:not(:disabled) {
  background-color: #2563eb;
}
.invoice-form-container .current-service-form .service-form-actions .add-current-service-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.invoice-form-container .current-service-form .service-form-actions .cancel-edit-btn {
  background-color: #6b7280;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .current-service-form .service-form-actions .cancel-edit-btn:hover {
  background-color: #4b5563;
}
.invoice-form-container .summary {
  background: var(--grey-shade-three);
  padding: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #e5e7eb;
  margin: 1rem 0 0 0;
}
.invoice-form-container .summary p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0;
  font-size: 0.875rem;
  color: #374151;
}
.invoice-form-container .summary p:first-child {
  margin-top: 0;
}
.invoice-form-container .summary p:last-child {
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #059669;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
}
.invoice-form-container .summary p strong {
  color: #111827;
  font-weight: 500;
}
.invoice-form-container .summary p span {
  font-size: 0.75rem;
  color: #6b7280;
  font-style: italic;
}
.invoice-form-container .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .invoice-form-container .form-actions {
    flex-direction: column;
  }
}
.invoice-form-container .form-actions .btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  border: none;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: var(--primary-color);
  color: white;
}
@media (max-width: 768px) {
  .invoice-form-container .form-actions .btn-primary {
    width: 100%;
  }
}
.invoice-form-container .form-actions .btn-primary:hover:not(:disabled) {
  background-color: #005a9a;
}
.invoice-form-container .form-actions .btn-primary:focus {
  outline: none;
}
.invoice-form-container .form-actions .btn-primary:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  opacity: 0.6;
  cursor: not-allowed;
}
.invoice-form-container .client-modal-header-inv .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}
.invoice-form-container .client-modal-header-inv .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}
.invoice-form-container .service-modal-body h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  text-align: center;
}
.invoice-form-container .service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
}
.invoice-form-container .service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.invoice-form-container .service-modal-body .btn-primary {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transform: translateX(10.7rem);
}
.invoice-form-container .service-modal-body .btn-primary:hover {
  background-color: #005a9a;
}
.invoice-form-container .service-modal-body .btn-primary:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.invoice-form-container input:focus-visible,
.invoice-form-container select:focus-visible,
.invoice-form-container textarea:focus-visible,
.invoice-form-container button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

@keyframes invoice-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1024px) {
  .invoice-form-container .invoice-form-wrapper {
    width: 85%;
  }
  .invoice-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
@media (max-width: 768px) {
  .invoice-form-container {
    padding: 1rem;
  }
  .invoice-form-container .invoice-form-wrapper {
    width: 95%;
  }
  .invoice-form-container .form-section {
    padding: 1rem;
  }
  .invoice-form-container .invoice-form-header .invoice-form-title {
    font-size: 1.25rem;
  }
  .invoice-form-container .form-section h3 {
    font-size: 1rem;
  }
  .invoice-form-container .form-actions .btn-primary {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media (max-width: 480px) {
  .invoice-form-container {
    padding: 0.5rem;
  }
  .invoice-form-container .invoice-form-wrapper {
    padding: 0.75rem;
    width: 100%;
  }
  .invoice-form-container .form-section {
    padding: 0.75rem;
  }
  .invoice-form-container .invoice-form-header .invoice-form-title {
    font-size: 1.125rem;
  }
  .invoice-form-container .form-group input,
  .invoice-form-container .form-group select,
  .invoice-form-container .form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .invoice-form-container .form-group .amount-display {
    font-size: 0.8125rem;
    padding: 0.375rem;
  }
}
@media print {
  .invoice-form-container {
    background: white;
    padding: 0;
  }
  .invoice-form-container .invoice-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .invoice-form-container .form-section {
    box-shadow: none;
    border: 1px solid #000;
    page-break-inside: avoid;
  }
  .invoice-form-container .form-actions,
  .invoice-form-container .service-card-actions,
  .invoice-form-container .service-form-actions {
    display: none;
  }
}
/* MODIFICATION: ADDED STYLES FOR THE NEW "ADD SERVICE" MODAL */
.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Higher z-index for modals */
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #e5e7eb;
  position: relative;
  animation: invoice-form-fade-in 0.2s ease-out; /* Re-using existing animation */
}
.confirmation-modal.notinvoice {
  width: 420px; /* Specific width for the small modal */
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.confirmation-actions.notinvoice {
  padding-top: 0;
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn:disabled,
.confirmation-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover:not(:disabled) {
  filter: brightness(95%);
}
.confirmation-actions .confirm-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.add-new-field-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.add-new-field-modal-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
  border-bottom: none;
  padding-bottom: 0;
}
.add-new-field-modal-content .add-new-field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.add-new-field-modal-content .add-new-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.confirmation-modal .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  position: absolute;
  top: 12px;
  right: 12px;
}
.confirmation-modal .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}`, "",{"version":3,"sources":["webpack://./src/forms/InvoiceForm/InvoiceForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EAXF;IAYI,aAAA;EACF;AACF;AAEE;;EAEE,wBAAA;EACA,SAAA;AAAJ;AAIE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,6CAAA;EACA,UAAA;AAFJ;AAII;EATF;IAUI,aAAA;IACA,UAAA;EADJ;AACF;AAKE;EACE,cAAA;EACA,oBAAA;AAHJ;AAOE;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AALJ;AAOI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AALN;AAOM;EANF;IAOI,kBAAA;EAJN;AACF;AASE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAPJ;AAWE;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AATJ;AAaE;EACE,uBAAA;EACA,uBAAA;EACA,qBAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EATF;IAUI,aAAA;EAXJ;AACF;AAaI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAXN;AAaM;EACE,cAAA;EACA,oBAAA;AAXR;AAiBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,gBAAA;AAfN;AAkBI;EATF;IAUI,sBAAA;IACA,WAAA;EAfJ;AACF;AAkBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAhBJ;AAkBI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAhBN;AAkBM;EACE,cAAA;EACA,oBAAA;AAhBR;AAqBI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAnBN;AAqBM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjBR;AAoBM;;;EACE,qBAAA;AAhBR;AAmBM;;;EACE,cAAA;AAfR;AAkBM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAdR;AAkBI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAhBN;AAmBI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAjBN;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAnBN;AAwBE;EACE,qBAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAtBN;AAwBM;EACE,qBAAA;EACA,yCAAA;AAtBR;AAyBM;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvBR;AAyBQ;EANF;IAOI,sBAAA;IACA,oBAAA;IACA,SAAA;EAtBR;AACF;AAyBM;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;AAvBR;AAyBQ;EANF;IAOI,sBAAA;IACA,oBAAA;IACA,YAAA;EAtBR;AACF;AAyBM;EACE,SAAA;AAvBR;AAyBQ;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvBV;AA0BQ;EACE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAxBV;AA4BM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AA1BR;AA4BQ;EAPF;IAQI,8BAAA;EAzBR;AACF;AA2BQ;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAzBV;AA6BM;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AA3BR;AA6BQ;EALF;IAMI,cAAA;IACA,uBAAA;EA1BR;AACF;AA4BQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA1BV;AA4BU;EACE,yBAAA;AA1BZ;AA6BU;EACE,yBAAA;EACA,mBAAA;AA3BZ;AA+BQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA7BV;AA+BU;EACE,yBAAA;AA7BZ;AAgCU;EACE,yBAAA;EACA,mBAAA;AA9BZ;AAsCE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AApCJ;AAsCI;EACE,mBAAA;AApCN;AAsCM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApCR;AAwCI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAtCN;AAwCM;EALF;IAMI,sBAAA;IACA,YAAA;EArCN;AACF;AAwCI;EACE,mBAAA;AAtCN;AAwCM;EACE,SAAA;AAtCR;AA0CI;EACE,aAAA;EACA,YAAA;EACA,yBAAA;AAxCN;AA0CM;EALF;IAMI,sBAAA;EAvCN;AACF;AAyCM;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AAvCR;AAyCQ;EACE,yBAAA;AAvCV;AA0CQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAxCV;AA4CM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA1CR;AA4CQ;EACE,yBAAA;AA1CV;AAiDE;EACE,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA/CN;AAiDM;EACE,aAAA;AA/CR;AAkDM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;AAhDR;AAmDM;EACE,cAAA;EACA,gBAAA;AAjDR;AAoDM;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAlDR;AAwDE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAtDJ;AAwDI;EARF;IASI,sBAAA;EArDJ;AACF;AAuDI;EACE,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,sCAAA;EACA,YAAA;AArDN;AAuDM;EAZF;IAaI,WAAA;EApDN;AACF;AAsDM;EACE,yBAAA;AApDR;AAuDM;EACE,aAAA;AArDR;AAwDM;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAtDR;AA6DI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA3DN;AA6DM;EACE,cAAA;EACA,yBAAA;AA3DR;AAiEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AA/DN;AAkEI;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAhEN;AAkEM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhER;AAoEI;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AAlEN;AAoEM;EACE,yBAAA;AAlER;AAqEM;EACE,yBAAA;EACA,mBAAA;AAnER;AAyEE;;;;EAIE,0BAAA;EACA,mBAAA;AAvEJ;;AA4EA;EACE;IACE,UAAA;IACA,2BAAA;EAzEF;EA2EA;IACE,UAAA;IACA,wBAAA;EAzEF;AACF;AA6EA;EAEI;IACE,UAAA;EA5EJ;EA+EE;IACE,sBAAA;IACA,WAAA;EA7EJ;AACF;AAiFA;EACE;IACE,aAAA;EA/EF;EAiFE;IACE,UAAA;EA/EJ;EAkFE;IACE,aAAA;EAhFJ;EAmFE;IACE,kBAAA;EAjFJ;EAoFE;IACE,eAAA;EAlFJ;EAsFI;IACE,oBAAA;IACA,oBAAA;EApFN;AACF;AAyFA;EACE;IACE,eAAA;EAvFF;EAyFE;IACE,gBAAA;IACA,WAAA;EAvFJ;EA0FE;IACE,gBAAA;EAxFJ;EA2FE;IACE,mBAAA;EAzFJ;EA6FI;;;IAGE,iBAAA;IACA,oBAAA;EA3FN;EA8FI;IACE,oBAAA;IACA,iBAAA;EA5FN;AACF;AAkGA;EACE;IACE,iBAAA;IACA,UAAA;EAhGF;EAkGE;IACE,gBAAA;IACA,sBAAA;EAhGJ;EAmGE;IACE,gBAAA;IACA,sBAAA;IACA,wBAAA;EAjGJ;EAoGE;;;IAGE,aAAA;EAlGJ;AACF;AAsGA,+DAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,8BAAA;EACA,aAAA;EACA,sBAAA;AArGF;;AAwGA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA,EAAA,gCAAA;AArGF;AAuGE;EACE,YAAA,EAAA,uCAAA;AArGJ;;AAyGA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAtGF;AAwGE;EACE,cAAA;AAtGJ;AAyGE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAvGJ;AAyGI;;EACE,mBAAA;EACA,YAAA;AAtGN;AA0GE;EACE,gCAAA;EACA,YAAA;AAxGJ;AA0GI;EACE,uBAAA;AAxGN;AA2GI;EACE,yBAAA;EACA,cAAA;AAzGN;AA6GE;EACE,mBAAA;EACA,YAAA;AA3GJ;AA6GI;EACE,mBAAA;AA3GN;;AAiHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9GF;AAgHE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AA9GJ;AAiHE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AA/GJ;AAiHI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA/GN;;AAqHA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAlHF;AAoHE;EACE,cAAA;EACA,yBAAA;AAlHJ","sourcesContent":["// Main Container\n.invoice-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  // Remove number input spinners\n  .no-spinner::-webkit-outer-spin-button,\n  .no-spinner::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  // Form Content Wrapper\n  .invoice-form-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    animation: invoice-form-fade-in 0.3s ease-out;\n    width: 70%;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      width: 95%;\n    }\n  }\n\n  // Required field indicator\n  .invoice-form-required {\n    color: #ef4444;\n    margin-left: 0.25rem;\n  }\n\n  // Header styling\n  .invoice-form-header {\n    position: relative;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    .invoice-form-title {\n      font-size: 1.3rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n  }\n\n  // Divider styling\n  .invoice-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  // Form content styling\n  .invoice-form-content {\n    padding: 0;\n    margin: 0;\n    border: none;\n    background: transparent;\n  }\n\n  // Form sections\n  .form-section {\n    background: transparent;\n    border-radius: 0.375rem;\n    margin-bottom: 1.5rem;\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n    }\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n\n      .invoice-form-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n  }\n\n  // Form rows and groups\n  .form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n\n  .form-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n\n      .invoice-form-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n    // Input styling\n    input,\n    select,\n    textarea {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151;\n      background: #ffffff;\n      box-sizing: border-box;\n      height: 2.5rem;\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:focus) {\n        border-color: #9ca3af;\n      }\n\n      &::placeholder {\n        color: #9ca3af;\n      }\n\n      &:disabled {\n        background-color: #f9fafb;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n    select {\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1.5rem 1.5rem;\n      padding-right: 2.5rem;\n    }\n\n    textarea {\n      height: auto;\n      min-height: 4rem;\n      resize: vertical;\n      line-height: 1.5;\n    }\n\n    // Green amount display\n    .amount-display {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 2.5rem;\n      font-weight: 600;\n      color: #059669;\n      background: #ecfdf5;\n      border: 1px solid #d1fae5;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      min-width: 100px;\n    }\n  }\n\n  // Added Services Cards\n  .added-services-container {\n    margin-bottom: 1.5rem;\n\n    .service-card {\n      background: #f8fafc;\n      border: 1px solid #e2e8f0;\n      border-radius: 8px;\n      margin-bottom: 1rem;\n      transition: all 0.2s ease;\n\n      &:hover {\n        border-color: #cbd5e1;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n      }\n\n      .service-card-content {\n        padding: 1rem;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          align-items: stretch;\n          gap: 1rem;\n        }\n      }\n\n      .service-card-main {\n        display: flex;\n        flex: 1;\n        justify-content: space-between;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          align-items: stretch;\n          gap: 0.75rem;\n        }\n      }\n\n      .service-info {\n        flex: 1;\n\n        h4 {\n          margin: 0 0 0.25rem 0;\n          font-size: 1rem;\n          font-weight: 600;\n          color: #1f2937;\n        }\n\n        .service-description {\n          margin: 0;\n          font-size: 0.875rem;\n          color: #6b7280;\n          font-style: italic;\n        }\n      }\n\n      .service-details {\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n        font-size: 0.875rem;\n        color: #4b5563;\n\n        @media (max-width: 768px) {\n          justify-content: space-between;\n        }\n\n        .service-amount {\n          font-weight: 600;\n          color: #059669;\n          font-size: 1rem;\n        }\n      }\n\n      .service-card-actions {\n        display: flex;\n        gap: 0.5rem;\n        margin-left: 1rem;\n\n        @media (max-width: 768px) {\n          margin-left: 0;\n          justify-content: center;\n        }\n\n        .edit-service-btn {\n          background-color: #3b82f6;\n          color: white;\n          border: none;\n          padding: 0.375rem 0.75rem;\n          border-radius: 0.25rem;\n          font-size: 0.75rem;\n          font-weight: 500;\n          cursor: pointer;\n          transition: background-color 0.2s ease;\n\n          &:hover:not(:disabled) {\n            background-color: #2563eb;\n          }\n\n          &:disabled {\n            background-color: #9ca3af;\n            cursor: not-allowed;\n          }\n        }\n\n        .delete-service-btn {\n          background-color: #ef4444;\n          color: white;\n          border: none;\n          padding: 0.375rem 0.75rem;\n          border-radius: 0.25rem;\n          font-size: 0.75rem;\n          font-weight: 500;\n          cursor: pointer;\n          transition: background-color 0.2s ease;\n\n          &:hover:not(:disabled) {\n            background-color: #dc2626;\n          }\n\n          &:disabled {\n            background-color: #9ca3af;\n            cursor: not-allowed;\n          }\n        }\n      }\n    }\n  }\n\n  // Current Service Form\n  .current-service-form {\n    background: #ffffff;\n    border: 2px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 1.5rem;\n\n    .service-form-header {\n      margin-bottom: 1rem;\n\n      h4 {\n        margin: 0;\n        font-size: 1rem;\n        font-weight: 600;\n        color: #374151;\n      }\n    }\n\n    .service-form-row {\n      display: flex;\n      gap: 1rem;\n      margin-bottom: 1rem;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        gap: 0.75rem;\n      }\n    }\n\n    .service-description-row {\n      margin-bottom: 1rem;\n\n      .description-group {\n        flex: 1;\n      }\n    }\n\n    .service-form-actions {\n      display: flex;\n      gap: 0.75rem;\n      justify-content: flex-end;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n      }\n\n      .add-current-service-btn {\n        background-color: var(--primary-color);\n        color: white;\n        border: none;\n        padding: 0.5rem 1rem;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background-color 0.2s ease;\n\n        &:hover:not(:disabled) {\n          background-color: #2563eb;\n        }\n\n        &:disabled {\n          background-color: #9ca3af;\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n      }\n\n      .cancel-edit-btn {\n        background-color: #6b7280;\n        color: white;\n        border: none;\n        padding: 0.5rem 1rem;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background-color 0.2s ease;\n\n        &:hover {\n          background-color: #4b5563;\n        }\n      }\n    }\n  }\n\n  // Invoice Summary\n  .summary {\n    background: var(--grey-shade-three);\n    padding: 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid #e5e7eb;\n    margin: 1rem 0 0 0;\n\n    p {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin: 0.5rem 0;\n      font-size: 0.875rem;\n      color: #374151;\n\n      &:first-child {\n        margin-top: 0;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n        font-size: 1rem;\n        font-weight: 600;\n        color: #059669;\n        border-top: 1px solid #e5e7eb;\n        padding-top: 0.75rem;\n        margin-top: 0.75rem;\n      }\n\n      strong {\n        color: #111827;\n        font-weight: 500;\n      }\n\n      span {\n        font-size: 0.75rem;\n        color: #6b7280;\n        font-style: italic;\n      }\n    }\n  }\n\n  // Form actions\n  .form-actions {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .btn-primary {\n      padding: 0.75rem 1.5rem;\n      border-radius: 0.25rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      border: none;\n      min-width: 120px;\n      transition: all 0.2s ease;\n      background-color: var(--primary-color);\n      color: white;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &:hover:not(:disabled) {\n        background-color: #005a9a;\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  // Modal styles\n  .client-modal-header-inv {\n    .close-cross {\n      background: none;\n      border: none;\n      font-size: 1.5rem;\n      color: #6b7280;\n      cursor: pointer;\n      padding: 0;\n      width: 2rem;\n      height: 2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 0.25rem;\n\n      &:hover {\n        color: #374151;\n        background-color: #f3f4f6;\n      }\n    }\n  }\n\n  .service-modal-body {\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      text-align: center;\n    }\n\n    .new-service-input {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      margin-bottom: 1rem;\n      box-sizing: border-box;\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n    }\n\n    .btn-primary {\n      background-color: var(--primary-color);\n      color: white;\n      border: none;\n      padding: 0.5rem 1rem;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      cursor: pointer;\n      transform: translateX(10.7rem);\n\n      &:hover {\n        background-color: #005a9a;\n      }\n\n      &:disabled {\n        background-color: #9ca3af;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  // Focus visible improvements for accessibility\n  input:focus-visible,\n  select:focus-visible,\n  textarea:focus-visible,\n  button:focus-visible {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n}\n\n// Animations\n@keyframes invoice-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Responsive design improvements\n@media (max-width: 1024px) {\n  .invoice-form-container {\n    .invoice-form-wrapper {\n      width: 85%;\n    }\n\n    .form-row {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .invoice-form-container {\n    padding: 1rem;\n\n    .invoice-form-wrapper {\n      width: 95%;\n    }\n\n    .form-section {\n      padding: 1rem;\n    }\n\n    .invoice-form-header .invoice-form-title {\n      font-size: 1.25rem;\n    }\n\n    .form-section h3 {\n      font-size: 1rem;\n    }\n\n    .form-actions {\n      .btn-primary {\n        padding: 0.5rem 1rem;\n        font-size: 0.8125rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .invoice-form-container {\n    padding: 0.5rem;\n\n    .invoice-form-wrapper {\n      padding: 0.75rem;\n      width: 100%;\n    }\n\n    .form-section {\n      padding: 0.75rem;\n    }\n\n    .invoice-form-header .invoice-form-title {\n      font-size: 1.125rem;\n    }\n\n    .form-group {\n      input,\n      select,\n      textarea {\n        padding: 0.375rem;\n        font-size: 0.8125rem;\n      }\n\n      .amount-display {\n        font-size: 0.8125rem;\n        padding: 0.375rem;\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .invoice-form-container {\n    background: white;\n    padding: 0;\n\n    .invoice-form-wrapper {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .form-section {\n      box-shadow: none;\n      border: 1px solid #000;\n      page-break-inside: avoid;\n    }\n\n    .form-actions,\n    .service-card-actions,\n    .service-form-actions {\n      display: none;\n    }\n  }\n}\n\n/* MODIFICATION: ADDED STYLES FOR THE NEW \"ADD SERVICE\" MODAL */\n\n.confirmation-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050; /* Higher z-index for modals */\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.confirmation-modal {\n  background: #ffffff;\n  padding: 24px;\n  border-radius: 8px;\n  max-width: 95%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: 1px solid #e5e7eb;\n  position: relative;\n  animation: invoice-form-fade-in 0.2s ease-out; /* Re-using existing animation */\n\n  &.notinvoice {\n    width: 420px; /* Specific width for the small modal */\n  }\n}\n\n.confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n\n  &.notinvoice {\n    padding-top: 0;\n  }\n\n  .confirm-btn,\n  .cancel-btn {\n    padding: 8px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 80px;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n\n  .confirm-btn {\n    background: var(--primary-color);\n    color: white;\n\n    &:hover:not(:disabled) {\n      filter: brightness(95%);\n    }\n\n    &:disabled {\n      background-color: #d1d5db;\n      color: #9ca3af;\n    }\n  }\n\n  .cancel-btn {\n    background: #6b7280;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #4b5563;\n    }\n  }\n}\n\n// Styles for the content within the new modal\n.add-new-field-modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n    text-align: left;\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  .add-new-field-input {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 14px;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n\n// Ensure close button inside the new modal is styled correctly\n.confirmation-modal .close-cross {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.25rem;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n\n  &:hover {\n    color: #374151;\n    background-color: #f3f4f6;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
